module.exports = __webpack_public_path__ + "4503b6de.png";